import { ActionTree } from 'vuex'
import { RootState } from '@/store/types'
import { AccountState, StoreError } from './types'
import { AccountInterface, AccountService } from '@/domain/services/AccountService'

const account: AccountInterface = new AccountService()

export const actions: ActionTree<AccountState, RootState> = {
  async sendCredentials ({ commit }, credentials) {
    try {
      const actionResponse = await account.sendCredentials(credentials)
      return commit(actionResponse.type, actionResponse.payload)
    } catch (error) {
      const storeError: StoreError = { state: true, message: error, name: 'STORE_ERROR' }
      return commit('STORE_ERROR', storeError)
    }
  },
  async passwordUpdate ({ commit }, password) {
    try {
      const actionResponse = await account.passwordUpdate(password)
      return commit(actionResponse.type, actionResponse.payload)
    } catch (error) {
      const storeError: StoreError = { state: true, message: error, name: 'STORE_ERROR' }
      return commit('STORE_ERROR', storeError)
    }
  },
  async alertUpdate ({ commit }, { alertaMovil, alertaCorreo }) {
    try {
      const actionResponse = await account.alertUpdate(alertaMovil, alertaCorreo)
      return commit(actionResponse.type, { ...actionResponse.payload, alertaCorreo, alertaMovil })
    } catch (error) {
      const storeError: StoreError = { state: true, message: error, name: 'STORE_ERROR' }
      return commit('STORE_ERROR', storeError)
    }
  },
  async logout ({ commit }) {
    try {
      const actionResponse = await account.logout()
      return commit(actionResponse.type)
    } catch (error) {
      const storeError: StoreError = { state: true, message: error, name: 'STORE_ERROR' }
      return commit('STORE_ERROR', storeError)
    }
  },
  async getCredentials ({ commit }) {
    try {
      const actionResponse = await account.getCookieCredentials()
      return commit(actionResponse.type, actionResponse.payload)
    } catch (error) {
      const storeError: StoreError = { state: true, message: error, name: 'STORE_ERROR' }
      return commit('STORE_ERROR', storeError)
    }
  }
}
